export const NAZK_TEXTS_LISTS: Record<string, string> = {
    title: "Відповідь на запит до Єдиного державного реєстру осіб, які вчинили корупційні або пов’язані з корупцією правопорушення",
    formation_date: "Дата формування:",
    ur_person: "Найменування юрособи / фізичної особи-підприємця",
    id_code: "Ідентифікаційний код в ЄДР",
    criminal_mark: "Позначка про відсутність / наявність правопорушень",
    criminal_empty: "За результатами пошуку не було знайдено інформації про корупційні або пов'язані з корупцією правопорушення",
    criminal_full: "За результатами пошуку було знайдено корупційні або пов'язані з корупцією правопорушення",
};
